// helpUrl — 「使い方」ボタン (2026-09-22 作者決定) が開く www マニュアルの URL。
//
// 部屋の中から使い方マニュアル (www の `/help/`) を開ける入口。Classic 上部バー /
// Modern ヘッダ / スマホ「その他」シートの 3 箇所から同じ URL 生成を使う (= ドリフト
// 防止で 1 箇所に集約)。押すと別タブで開く (`window.open(url, '_blank',
// 'noopener,noreferrer')`、呼び出し側が担う)。
//
// `env` はいまのシェル (Classic レイアウト / Modern デスクトップ / フォンシェル) を
// クエリで渡す。マニュアル項目としては扱わない (= `data-manual` は付けない、
// `manualRegistry.ts` の登録対象外)。

/** 使い方ボタンを置く 3 つのシェル。 */
export type HelpEnv = 'classic' | 'modern' | 'phone';

/** www マニュアルのトップ URL。 */
const HELP_BASE_URL = 'https://www.takamin.com/help/';

/** 使い方ボタンの遷移先 URL (`env` はいまのシェルを表す固定値)。 */
export const buildHelpUrl = (env: HelpEnv): string => `${HELP_BASE_URL}?env=${env}`;
